/*
 * @Author: lishiqiao
 * @Date: 2023-02-23 14:04:52
 * @LastEditors: lishiqiao
 * @LastEditTime: 2023-02-23 14:04:54
 */
//解决this指向问题，在window.addEventListener中this是指向window的。
//需要将vue实例赋值给_this,这样在window.addEventListener中通过_this可以为vue实例上data中的变量赋值
// let _this=this;
//根据自己需要来监听对应的key
// window.addEventListener("setItemEvent",function(e){
	//e.key : 是值发生变化的key
	//例如 e.key==="token";
	//e.newValue : 是可以对应的新值
	// if(e.key==="token"){
	// 	console.log(e.newValue);
	// 	_this.token=e.newValue;
	// }
function dispatchEventStroage() {
    const signSetItem = localStorage.setItem
    localStorage.setItem = function (key, val) {
        let setEvent = new Event('setItemEvent')
        setEvent.key = key
        setEvent.newValue = val
        window.dispatchEvent(setEvent)
        signSetItem.apply(this, arguments)
    }
}

export default dispatchEventStroage